<script lang="ts" setup>
import { UiIcon } from '@common/ui-kit'
import IconServiceChecker from "~/components/sx/icons/services/IconServiceChecker.vue";
import IconServiceIpn from "~/components/sx/icons/services/IconServiceIpn.vue";
import {capitalize} from "vue";
import PopupPrices from "~/components/sx/popupContent/PopupPrices.vue";

const { t } = useI18n();
const { locale: localeI18n } = useI18n();

const items = shallowRef({
  extra: {
    titleKey: 'components.popupProxy.extra.title',
    content: [
      {
        icon: 'paid',
        blank: false,
        nameKey: 'components.popupProxy.extra.prices.name',
        descKey: 'components.popupProxy.extra.prices.desc',
        sub: '',
        link: '#prices',
        translate: true,
      },
      {
        icon: 'language',
        blank: false,
        nameKey: 'components.popupProxy.extra.geo.name',
        descKey: 'components.popupProxy.extra.geo.desc',
        sub: '',
        link: 'geo',
        translate: false,
      },
      {
        icon: 'handyman',
        blank: false,
        nameKey: 'components.popupProxy.extra.developers.name',
        descKey: 'components.popupProxy.extra.developers.desc',
        sub: '',
        link: 'developers',
        translate: true,
      },
    ],
  },
  services: {
    titleKey: 'components.popupProxy.services.title',
    content: [
      {
        icon: markRaw(IconServiceChecker),
        blank: true,
        nameKey: 'components.popupProxy.services.checker.name',
        descKey: 'components.popupProxy.services.checker.desc',
        sub: '',
        link: 'https://checker.net',
        translate: false,
      },
      {
        icon: markRaw(IconServiceIpn),
        nameKey: 'components.popupProxy.services.ipInfo.name',
        blank: true,
        descKey: 'components.popupProxy.services.ipInfo.desc',
        sub: '',
        link: 'https://i.pn',
        translate: false,
      },
    ],
  }
});
</script>

<template>
  <div class="popup-content-proxy">
    <PopupPrices />
    <div v-for="block in items" class="popup-content-proxy__block">
      <div class="popup-content-proxy__title">
        {{ capitalize($t(block.titleKey)) }}
      </div>
      <div class="popup-content-proxy__content">
        <NuxtLink
          v-for="(item, index) in block.content" :key="index"
          :to="item.blank ? item.link : `/${localeI18n}/${item.link}`"
          :target="item.blank ? '_blank' : '_self'"
          class="popup-content-proxy__link"
        >
           <div class="popup-content-proxy__name">
             <UiIcon v-if="!item.blank" type="filled" :name="item.icon" />
             <Component v-else :is="item.icon" />
             {{ item.translate ? capitalize($t(item.nameKey)) : $t(item.nameKey) }}
           </div>
            <div class="popup-content-proxy__desc">
              {{ capitalize($t(item.descKey)) }}
            </div>
          <div v-if="item.sub" class="popup-content-proxy__sub">
            {{ $t('components.prices.from') }} ${{ item.sub }}
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.popup-content-proxy {
  display: flex;
  gap: 32px;
  width: 100%;
  &__block {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 320px;
    width: 100%;
  }
  &__title {
    padding-bottom: 12px;
    border-bottom: var(--border-sx-main);
    font-weight: 500;
    font-size: 22px;
    line-height: 20px;
    letter-spacing: 0;
  }
  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &__link {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #000;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: -6px;
      left: -12px;
      right: -12px;
      bottom: -6px;
      border-radius: 16px;
      background: #efefef;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
      z-index: -1;
    }
    &:hover::before {
      opacity: 1;
    }
  }
  &__name {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__desc {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: #666666;
  }
  &__sub {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
  }
}
</style>
